export default __webpack_public_path__ + "static/media/notificationIcon.e5daa5ee.svg";